import React from "react";
import { Plus } from "lucide-react";
import { useCart } from "../context/CartContext";
import { formatPrice } from "../lib/api";
import { ProductImage } from "./ProductImage";

export const ProductCard = ({ product }) => {
  const { addItem } = useCart();

  return (
    <div className="product-card group" data-testid={`product-card-${product.id}`}>
      <div className="product-image">
        <ProductImage src={product.image_url} alt={product.name}
          testId={`product-image-${product.id}`} className="w-full h-full" />
        {product.featured && (
          <span className="absolute top-3 left-3 bg-[#d4af37] text-[#0a0f1a] text-[9px] font-bold uppercase tracking-widest px-2 py-1 z-10" data-testid={`product-featured-${product.id}`}>
            Signature
          </span>
        )}
      </div>
      <div className="p-4 flex flex-col gap-3 flex-1">
        <h3 className="font-display text-lg text-white leading-tight" data-testid={`product-name-${product.id}`}>
          {product.name}
        </h3>
        {product.description && (
          <p className="text-xs text-gray-400 line-clamp-2 leading-relaxed" data-testid={`product-description-${product.id}`}>{product.description}</p>
        )}
        <div className="flex items-center justify-between mt-auto pt-3 border-t border-white/5">
          <span className="text-gold font-display text-xl" data-testid={`product-price-${product.id}`}>
            {formatPrice(product.price)}
          </span>
          <button
            onClick={() => addItem(product, 1)}
            data-testid={`add-to-cart-btn-${product.id}`}
            className="bg-[#d4af37] hover:bg-[#f3e5ab] text-[#0a0f1a] p-2 transition-colors"
            aria-label={`Ajouter ${product.name}`}
          >
            <Plus size={18} strokeWidth={2.5} />
          </button>
        </div>
      </div>
    </div>
  );
};
